import { useCallback, useEffect, useState } from 'react';
import { api, type PrRegistryRow } from '../../api.js';

const POLL_INTERVAL_MS = 30_000;

export function useOpenPrs(): {
  rows: PrRegistryRow[];
  fetchedAt: string | null;
  loading: boolean;
  error: string | null;
} {
  const [rows, setRows] = useState<PrRegistryRow[]>([]);
  const [fetchedAt, setFetchedAt] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const r = await api.getPrRegistry();
      setRows(r.rows);
      setFetchedAt(r.fetched_at);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [load]);

  return { rows, fetchedAt, loading, error };
}
